import StructuredData from './StructuredData';

interface SoftwareApplicationSchemaProps {
  name?: string;
  description?: string;
  image?: string;
  operatingSystem?: string;
  applicationCategory?: string;
  offers?: {
    price?: string;
    priceCurrency?: string;
  };
}

const SoftwareApplicationSchema: React.FC<SoftwareApplicationSchemaProps> = ({
  name = 'VxFx',
  description = 'Universal video plugin framework supporting Windows, macOS, and Linux. GPU-accelerated with CUDA, OpenCL, Metal, and DirectX.',
  image,
  operatingSystem = 'Windows, macOS, Linux',
  applicationCategory = 'MultimediaApplication',
  offers,
}) => {
  const siteUrl = process.env.SITE_URL || 'https://vxfx.io';

  const schema: any = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    image: image || `${siteUrl}/epenfav.webp`,
    operatingSystem,
    applicationCategory,
    url: siteUrl,
    ...(offers && {
      offers: {
        '@type': 'Offer',
        ...(offers.price && { price: offers.price }),
        priceCurrency: offers.priceCurrency || 'USD',
      },
    }),
  };

  return <StructuredData data={schema} />;
};

export default SoftwareApplicationSchema;
